import { Link, useForm } from '@inertiajs/react'

interface Account { id: number; name: string; slug: string; logo_url?: string | null; loyalty_points_enabled?: boolean }
interface Props { account: Account }

export default function CatalogCustomerRegister({ account }: Props) {
  const { data, setData, post, processing, errors } = useForm({
    name: '',
    email: '',
    phone: '',
    tax_id: '',
    password: '',
    password_confirmation: '',
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post(`/${account.slug}/portal/register`)
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white p-8 rounded-lg shadow">
        <Link href={`/${account.slug}/catalog`} className="flex items-center gap-2 font-bold text-lg mb-6 text-[#202020]">
          {account.logo_url && <img src={account.logo_url} className="h-8 w-8 object-contain bg-gray-100 rounded" />}
          {account.name}
        </Link>
        <h1 className="text-xl font-bold text-[#202020] mb-1">Crear cuenta</h1>
        <p className="text-sm text-gray-500 mb-4">{account.loyalty_points_enabled ? 'Regístrate para ver tus pedidos y puntos acumulados' : 'Regístrate para ver tus pedidos'}</p>

        <form onSubmit={handleSubmit} className="space-y-3">
          <div>
            <input type="text" placeholder="Nombre completo" value={data.name}
              onChange={(e) => setData('name', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#55ACEE]"
              required />
            {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
          </div>

          <div>
            <input type="email" placeholder="Correo electrónico" value={data.email}
              onChange={(e) => setData('email', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#55ACEE]"
              required />
            {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
          </div>

          <div>
            <input type="text" placeholder="DNI o RUC" value={data.tax_id}
              onChange={(e) => setData('tax_id', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#55ACEE]" />
            {errors.tax_id && <p className="text-red-500 text-xs mt-1">{errors.tax_id}</p>}
          </div>

          <div>
            <input type="tel" placeholder="Teléfono" value={data.phone}
              onChange={(e) => setData('phone', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#55ACEE]" />
            {errors.phone && <p className="text-red-500 text-xs mt-1">{errors.phone}</p>}
          </div>

          <div>
            <input type="password" placeholder="Contraseña" value={data.password}
              onChange={(e) => setData('password', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#55ACEE]"
              required />
            {errors.password && <p className="text-red-500 text-xs mt-1">{errors.password}</p>}
          </div>

          <div>
            <input type="password" placeholder="Confirmar contraseña" value={data.password_confirmation}
              onChange={(e) => setData('password_confirmation', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#55ACEE]"
              required />
          </div>

          <button type="submit" disabled={processing}
            className="w-full bg-[#FFC107] text-[#202020] py-2 rounded font-semibold hover:bg-[#e6ad06] disabled:opacity-50">
            {processing ? 'Creando cuenta...' : 'Crear cuenta'}
          </button>
        </form>

        <p className="text-xs text-gray-500 mt-4 text-center">
          ¿Ya tienes cuenta?{' '}
          <Link href={`/${account.slug}/portal/login`} className="text-[#55ACEE] hover:underline">
            Inicia sesión
          </Link>
        </p>
      </div>
    </div>
  )
}
